module.exports = __webpack_public_path__ + "static/media/detector.2dfb0569.png";